
import React from "react";
import { OrderCheckInWizard } from "./checkin/OrderCheckInWizard";

interface OrderCheckInProps {
  onBack: () => void;
  onSubmit: (orderData: any) => void;
}

export const OrderCheckIn = ({ onBack, onSubmit }: OrderCheckInProps) => {
  console.log('🔄 OrderCheckIn: Component rendering', { onBack: !!onBack, onSubmit: !!onSubmit });
  
  return (
    <OrderCheckInWizard 
      onBack={onBack}
      onSubmit={onSubmit}
    />
  );
};
